// // // import ActivityStore from "./activityStore";
//  //import {createContext, useContext} from "react";
// // import CommonStore from "./commonStore";
// // import UserStore from "./userStore";
// // import ModalStore from "./modalStore";
// // import CategoryStore from "./categoryStore";
// // // import ProductStore from "./productStore";
// // import ProductsStore from "./productsStore";
// // import NewArrivalProductsStore from "./newarrivalProductsStore";
// // import ParentCategoryStore from "./parentCategoryStore";
// // import CartStore from "./cartStore";
// // import BookingStore from "./bookingStore";
// // import WishlistStore from "./wishlistStore";
// // import SearchStore from "./searchStore";
// // import CouponStore from "./couponStore";

//  interface Store {    
// //     commonStore: CommonStore;
// //     userStore: UserStore;    
// //     modalStore: ModalStore;    
// //     categoryStore:CategoryStore;
// //     cartStore:CartStore;
// //     productsStore: ProductsStore;
// //     newarrivalProductsStore: NewArrivalProductsStore;
// //     parentCategoryStore:ParentCategoryStore;
// //     bookingStore:BookingStore;
// //     wishlistStore: WishlistStore;
// //     searchStore:SearchStore;
// //     couponStore:CouponStore;
//  }
//  export const store: Store = {
// //     commonStore: new CommonStore(),
// //     userStore: new UserStore(this),    
// //     modalStore: new ModalStore(),
// //     categoryStore:new CategoryStore(),
// //     cartStore:new CartStore(this),
// //     productsStore:new ProductsStore(),
// //     newarrivalProductsStore: new NewArrivalProductsStore(),
// //     parentCategoryStore: new ParentCategoryStore(),
// //     bookingStore:new BookingStore(),
// //     wishlistStore: new WishlistStore(),
// //     searchStore: new SearchStore(this),
// //     couponStore: new CouponStore(),
// // }
// // export const StoreContext = createContext(store);
// // export function useStore() {
// //     return useContext(StoreContext);
// }
// ... inside store.ts after the RootStore class definition ...

import { createContext, useContext } from "react";
import { RootStore } from "./rootStore";

// 1. Create the instance
export const store = new RootStore();

// 2. Create the Context (This is what index.tsx is missing)
export const StoreContext = createContext(store);

// 3. Helper hook for your components (used like: const { productStore } = useStore();)
export function useStore() {
    return useContext(StoreContext);
}
